import { useHistory } from 'react-router-dom';
import { RedirectArgs } from './types';
import { useScrollPageToTop } from '../use-scroll-page-to-top/use-scroll-page-to-top';

export const useRedirect = () => {
    const scrollPageToTop = useScrollPageToTop();
    const history = useHistory();

    const handleRedirect = ({ url, state, type = 'push', withScrollToTop = true }: RedirectArgs) => {
        const existUrl = url !== undefined;
        const redirect = type === 'push' ? history.push : history.replace;
        if (state && !existUrl) {
            redirect(state);
        } else if (existUrl) {
            redirect(url, state);
        }
        if (withScrollToTop) {
            scrollPageToTop();
        }
    };

    return handleRedirect;
};
